import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";

// material-ui
import { ButtonBase } from '@mui/material';

// project import
import {Logo200, Logo100, LogoCnWhite, LogoCnBlue, LogoCoro} from './Logo';
import { useSelector } from "react-redux";
import { useGetTenancyBasicsQuery } from "../../store/services/tenancy.service";
import { APP_URL } from "../../config";
import { useTheme } from "@mui/material/styles";

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const lightMode = theme.palette.mode === "light";
    const brandType = process.env.REACT_APP_BRAND_TYPE;

    const { tenancyId } = useSelector((state) => state.tenancy);
    const { isLoggedIn } = useSelector((state) => state.auth);

    const { data: tenancyData, error: tenancyError, isLoading: tenancyLoading } = useGetTenancyBasicsQuery({
        tenancyId: tenancyId
    });

    const handleClick = () => {
        if (!isLoggedIn) {
            navigate('/login');
            return;
        }

        navigate('/');
    };

    const renderLogo = () => {
        // First check if there's a custom tenancy logo
        if (!tenancyLoading && !tenancyError && tenancyData && tenancyData.logo) {
            return (
                <img
                    src={`${APP_URL}/${tenancyData.logo}`}
                    alt="Logo"
                    width="180"
                    height="100"
                    style={{objectFit: 'contain', marginTop: 8}}
                />
            );
        }

        // Then check brand type
        switch (brandType) {
            case 'censornet':
                return lightMode ? <LogoCnBlue /> : <LogoCnWhite />;
            case 'coro':
                return <LogoCoro />;
            default:
                return lightMode ? <Logo200 /> : <Logo100 />;
        }
    };

    return(
        <ButtonBase disableRipple onClick={handleClick}>
            {renderLogo()}
        </ButtonBase>
    );
};

export const LogoSectionBlue = () => {
    const navigate = useNavigate();
    const { isLoggedIn } = useSelector((state) => state.auth);

    const handleClick = () => {
        if (!isLoggedIn) {
            navigate('/login');
            return;
        }

        navigate('/');
    };

    return (
        <ButtonBase disableRipple onClick={handleClick}>
            <Logo100 />
        </ButtonBase>
    );
};

LogoSection.propTypes = {
    sx: PropTypes.object,
    to: PropTypes.string
};

export default LogoSection;